export default "__VITE_ASSET__K0FMBkpq__"